import { SimpleForm, required, useTranslate } from "react-admin";
import CollabPartnerTypeInput from "./inputs/CollabPartnerTypeInput";
import CollabPartnerTypeOtherInput from "./inputs/CollabPartnerTypeOtherInput";
import {
  CollaborationTypeInput,
  DocsInput,
  YesOrNoInput,
} from "../component/input";
import FormalizationTypeInput from "./inputs/FormalizationTypeInput";
import React from "react";
import ResultDetailsInput from "./inputs/ResultDetailsInput";
import ResultTypeInput from "./inputs/ResultTypeInput";
import ResultTypeOtherInput from "./inputs/ResultTypeOtherInput";
import {
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
  Toolbar,
} from "ra-friendsofbabba";

const Form = ({ classes, ...props }) => {
  const translate = useTranslate();
  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backTab={2}
          backReference="technical-reports"
          backReferenceTarget="technical_report_id"
        />
      }
    >
      <Group wrapper>
        <GroupTitle
          title={translate("resources.technical-report-collaborations.name", {
            smart_count: 1,
          })}
        />
      </Group>
      <DebouncedTextInput
        source="subject_name"
        maxLength={200}
        validate={[required()]}
        multiline
        fullWidth
      />
      <DebouncedTextInput
        source="description"
        minLength={500}
        maxLength={3000}
        validate={[required()]}
        multiline
        fullWidth
      />
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <CollabPartnerTypeInput
            source="collab_partner_type_id"
            validate={required()}
          />
        </GroupItem>
      </Group>
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <CollabPartnerTypeOtherInput source="collab_partner_type_other" />
        </GroupItem>
      </Group>
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <CollaborationTypeInput
            source="collaboration_type_id"
            validate={required()}
          />
        </GroupItem>
      </Group>
      <YesOrNoInput source="is_expected" validate={required()} />
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <FormalizationTypeInput
            source="formalization_type_id"
            validate={required()}
          />
        </GroupItem>
      </Group>
      <DebouncedTextInput
        source="details"
        maxLength={1000}
        validate={[required()]}
        multiline
        fullWidth
      />
      <Group wrapper>
        <GroupTitle
          title={translate(
            "resources.technical-report-collaborations.section.results"
          )}
          divider={false}
        />
      </Group>
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <ResultTypeInput source="result_type_id" />
        </GroupItem>
      </Group>

      <ResultTypeOtherInput source="result_type_other" />
      <ResultDetailsInput
        source="result_details"
        maxLength={1000}
        multiline
        fullWidth
      />
      <DocsInput source="docs" fullWidth />
    </SimpleForm>
  );
};
export default Form;
